import script from "./LeagueSelectionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueSelectionView.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueSelectionView.vue?vue&type=style&index=0&id=42ca4faa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ca4faa"]])

export default __exports__